module.exports = __webpack_public_path__ + "3b5e86d2a2c0a8c5998a6a518d584641.png";